import axios from "axios";

export default {
  methods: {
    /**
     * Recupera informações do prestador
     * @param {Number} id
     * @return {
     * {
     *   "codigo": "string",
     *   "cpfCnpj": "string",
     *   "dtExclusaoProgramada": "string",
     *   "id": 0,
     *   "nome": "string",
     *   "podeAprovarReprovar": true,
     *   "podeEnviarArquivo": true,
     *   "rede": {
     *   "chave": "PROCESSANDO",
     *   "descricao": "string"
     *   },
     *   "status": {
     *   "chave": "PROCESSANDO",
     *   "descricao": "string"
     *   },
     *   "tipo": {
     *   "chave": "PROCESSANDO",
     *   "descricao": "string"
     *   },
     *   "unimedOrigem": "string"
     *}
     * }
     */
    getDetalhePrestador(id) {
      return axios.get(
        this.CriarUrl({
          resource: `prestadores/${id}`
        })
      );
    }
  }
};
